import React, { useEffect, useRef, useState } from "react";
import { Dialog, IconButton, Box, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";

export const VideoModalBtn = ({ src, sx }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="outlined"
        onClick={() => setOpen(true)}
        startIcon={<VideoCameraBackIcon />}
        sx={{ ...sx }}
      >
        Open Demo Video
      </Button>

      <VideoModal
        open={open}
        onClose={() => setOpen(false)}
        src={src}
        height="70vh"
        width="80vw"
      />
    </>
  );
};

export default function VideoModal({
  open,
  onClose,
  src,
  autoPlay = true,
  height = "60vh",
  width = "90vw",
}) {
  const videoRef = useRef(null);

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    onClose();
  };

  useEffect(() => {
    if (!open && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          background: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          zIndex: 10,
          background: "rgba(0,0,0,0.5)",
          color: "white",
          "&:hover": { background: "rgba(0,0,0,0.7)" },
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Video Container */}
      <Box
        sx={{
          width,
          height,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Native HTML5 Video */}
        <video
          ref={videoRef}
          src={src}
          autoPlay={autoPlay}
          controls
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            background: "black",
            objectFit: "contain",
          }}
        />
      </Box>
    </Dialog>
  );
}
